import React from 'react';
import { ScrollView, View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Modal } from '@material-ui/core';

const OpenFloTerms = ({ isVisible, onClose }) => {
    return (
        <Modal
            open={isVisible ? isVisible : false}
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                paddingLeft: 10,
                paddingRight: 10,
                flex: 1
            }}
        >
            <View style={styles.overlay}>
                <View style={styles.modalContainer}>

                    <View style={styles.card}>
                        <Text style={styles.heading}>tlyfePro Terms and Conditions</Text>

                        <Text style={styles.sectionTitle}>Definitions:</Text>
                        <View style={styles.list}>
                            {[
                                ['Agent', 'An estate agent, letting agent or landlord who uses the Service.'],
                                ['Contract', 'The contract between Openbrix and either an Agent or a Tenant in accordance with these terms and the Terms and Conditions.'],
                                ['Deposit Service', 'The service referred to in clause 1.2.5.'],
                                ['Openbrix', 'Openbrix Ltd registered in England and Wales with company number 11305881.'],
                                ['Identity Service', 'The service referred to in clause 1.2.4.'],
                                ['Platform', 'The Openbrix Platform found at www.openbrix.co.uk.'],
                                ['Services', 'The various Agent Services and Tenant Services set out at clause 1.'],
                                ['Template', 'A document referred to in clause 1.1.2.'],
                                ['Tenant', 'A private tenant who uses the Services.'],
                                ['Terms and Conditions', 'The general terms and conditions of service of Openbrix.'],
                            ].map(([title, desc], i) => (
                                <Text key={i} style={styles.bullet}>
                                    <Text style={styles.bold}>{title}:</Text> {desc}
                                </Text>
                            ))}
                        </View>

                        <Text style={styles.sectionTitle}>1. SERVICES:</Text>
                        <Text style={styles.subHeading}>Agent Services:</Text>
                        <Text style={styles.bullet}>
                            1.1 Access to the Platform for uploading property details and documents such as tenancy agreements and EPCs.
                        </Text>
                        <Text style={styles.bullet}>
                            1.1.2 Access to a template Assured Shorthold Tenancy Agreement, Non-Housing Act Tenancy Agreement, and Prescribed Information Sheet.
                        </Text>

                        <Text style={styles.subHeading}>Tenant Services:</Text>
                        {[
                            '1.2.1 Access to the Platform to upload personal information for letting.',
                            '1.2.2 Uploading documentation for letting.',
                            '1.2.3 Access to external rental guarantee, insurance, and referencing services.',
                            '1.2.4 Access to an external digital identity service.',
                            '1.2.5 Access to an external deposit payment facilitation service.',
                        ].map((item, i) => (
                            <Text key={i} style={styles.bullet}>{item}</Text>
                        ))}

                        <Text style={styles.sectionTitle}>2. RESPONSIBILITIES OF AGENTS AND TENANTS:</Text>
                        <Text style={styles.subHeading}>Agents and Tenants:</Text>
                        {[
                            '2.1 Will comply with the Terms and Conditions.',
                            '2.2 Ensure uploaded info/documents are accurate.',
                            '2.3 Documents must be free from viruses or malicious content.',
                        ].map((item, i) => (
                            <Text key={i} style={styles.bullet}>{item}</Text>
                        ))}

                        <Text style={styles.subHeading}>Tenants:</Text>
                        {[
                            '2.4 Must comply with third party service terms.',
                            '2.5 Address complaints directly with the third party provider and copy Openbrix.',
                        ].map((item, i) => (
                            <Text key={i} style={styles.bullet}>{item}</Text>
                        ))}

                        <Text style={styles.sectionTitle}>3. Charges and Payment:</Text>
                        {[
                            '3.1 Details available separately.',
                            '3.2 All payments must be made in full without deductions (except as required by law).',
                        ].map((item, i) => (
                            <Text key={i} style={styles.bullet}>{item}</Text>
                        ))}

                        <Text style={styles.sectionTitle}>4. Termination:</Text>
                        <Text style={styles.bullet}>
                            4.1 Openbrix may suspend or terminate access if terms are breached.
                        </Text>

                        <Text style={styles.sectionTitle}>5. Limitation of Liability:</Text>
                        {[
                            '5.1 No liability for third-party actions or services.',
                            '5.2 Agents indemnify Openbrix for non-compliance or legal issues.',
                            '5.3.1 No guarantee Templates are fit for specific purposes.',
                            '5.3.2 Agents are responsible for Template modifications.',
                            '5.3.3 No advice is given on how to use Templates.',
                            '5.3.4 Identity Services may not be accepted by all agents.',
                            '5.3.5 Not all agents may use the Deposit Service.',
                        ].map((item, i) => (
                            <Text key={i} style={styles.bullet}>{item}</Text>
                        ))}

                        <Text style={styles.sectionTitle}>6. GENERAL:</Text>
                        {[
                            '6.1 Mediation: Parties agree to CEDR Model Mediation Procedure.',
                            '6.2 Governing Law: England and Wales.',
                            '6.3 Jurisdiction: Courts of England and Wales have exclusive jurisdiction.',
                        ].map((item, i) => (
                            <Text key={i} style={styles.bullet}>{item}</Text>
                        ))}
                    </View>
                    <View style={styles.actions}>
                    <TouchableOpacity
                    onPress={onClose}
                    style={styles.buyBtn}>
                    <Text style={styles.buyText}>Ok</Text>
              
                </TouchableOpacity>
                </View>
                </View>
               
            </View>
   
        </Modal>

    );
};

const styles = StyleSheet.create({
    actions: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
    buyBtn: {
        backgroundColor: '#6b21a8',
        paddingVertical: 10,
        paddingHorizontal: 28,
        borderRadius: 8,
        marginTop:10
    },
    buyText: {
        color: 'white',
        fontWeight: '600',
    },
    overlay: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContainer: {
        backgroundColor: 'white',
        borderRadius: 10,
        shadowColor: '#000',
        shadowOpacity: 0.2,
        shadowRadius: 5,
        elevation: 5,
    },
    container: {
        backgroundColor: '#f8f8f8',
    },
    card: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 12,
        shadowColor: '#000',
        shadowOpacity: 0.08,
        shadowRadius: 8,
        shadowOffset: { width: 0, height: 4 },
        elevation: 3,
        maxHeight: "80vh",
        overflow: "scroll"
    },
    heading: {
        fontSize: 24,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 20,
    },
    sectionTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginTop: 20,
        marginBottom: 10,
        color: '#4B0082',
    },
    subHeading: {
        fontSize: 16,
        fontWeight: '600',
        marginTop: 10,
        marginBottom: 5,
        color: '#6A5ACD',
    },
    bullet: {
        fontSize: 14,
        marginVertical: 4,
        color: '#333',
        lineHeight: 20,
    },
    bold: {
        fontWeight: 'bold',
    },
});

export default OpenFloTerms;
